import { Box, Checkbox, Table as Mantinetable, Text, UnstyledButton } from "@mantine/core"
import { CaretDownIcon, CaretUpDownIcon, CaretUpIcon } from "@phosphor-icons/react"
import { useTranslation } from "react-i18next"
import { Sort } from "../../../components/table"
import classes from "../list.module.css"
import { ColumnDef } from "./columns"

type Props = {
  columns: ColumnDef[]
  sorted: [string, Sort]
  onSort: (index: string) => void
  showSelect: boolean
  allSelected: boolean
  someSelected: boolean
  selectableCount: number
  onSelectAll: () => void
  onUnselectAll: () => void
}

export function SupplierSalesTableHead({
  columns, sorted, onSort, showSelect, allSelected, someSelected, selectableCount, onSelectAll, onUnselectAll,
}: Props) {
  const { t } = useTranslation(["supplierSales", "common"])
  return (
    <Mantinetable.Thead>
      <Mantinetable.Tr>
        {showSelect && (
          <Mantinetable.Th w={44}>
            <Checkbox
              aria-label={t("supplierSales:sales.list.selectAll")}
              checked={allSelected}
              indeterminate={someSelected && !allSelected}
              disabled={selectableCount === 0}
              onChange={() => (allSelected ? onUnselectAll() : onSelectAll())}
            />
          </Mantinetable.Th>
        )}
        <Mantinetable.Th>{t("common:table.action")}</Mantinetable.Th>
        {columns.map((c) => {
          const active = sorted[0] === c.sort
          const SortIcon = active ? (sorted[1] === Sort.ASC ? CaretUpIcon : CaretDownIcon) : CaretUpDownIcon
          return (
            <Mantinetable.Th key={c.id} ta={c.align === "right" ? "right" : undefined} aria-sort={active ? (sorted[1] === Sort.ASC ? "ascending" : "descending") : undefined}>
              {c.sort ? (
                <UnstyledButton onClick={() => onSort(c.sort!)} className={classes.sortButton} data-align={c.align}>
                  <Text span inherit>{t(`supplierSales:${c.label}`)}</Text>
                  <Box component="span" className={classes.sortIcon} data-active={active || undefined}>
                    <SortIcon size={14} className={active ? undefined : "sort-idle"} />
                  </Box>
                </UnstyledButton>
              ) : (
                t(`supplierSales:${c.label}`)
              )}
            </Mantinetable.Th>
          )
        })}
      </Mantinetable.Tr>
    </Mantinetable.Thead>
  )
}
